import { IntlShape } from 'react-intl';

const getModalHeading = (formatMessage: IntlShape['formatMessage']) =>
  formatMessage({ id: 'receipt' });

export default getModalHeading;
